import {
  Box,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Button,
  FormHelperText,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "../../../store/store";
import { LoadingButton } from "@mui/lab";
import { getUserContext } from "../../../shared/utils/utils";
import { isValidStringInput } from "../../../shared/utils/validator";
import { createFacility, updateFacility } from "../../../store/api/facility";
type Props = {
  pageMode: "VIEW" | "ADD" | "EDIT";
  selectedFacility: any;
  handleCancelClick: () => void;
  addFacility: (reqBody: any) => void;
  editFacility: (reqBody: any) => void;
  handleSetError: (message: string) => void;
  handleSetSuccess: (message: string) => void;
};
export const FacilityInputWizard = ({ pageMode, selectedFacility, handleCancelClick, addFacility, editFacility, handleSetError, handleSetSuccess }: Props) => {
  const storeFacilityState = useSelector((state: RootState) => state.facility);
  const userContext: any = getUserContext();
  const orgPartyId = userContext.orgPartyIds[0];
  const [facilityName, setFacilityName] = useState({
    value: selectedFacility?.facilityName ?? "",
    isError: false,
    errorMsg: "",
  });
  const [facilityTypeId, setFacilityTypeId] = useState({
    value: selectedFacility?.facilityTypeId ?? "Select Store Type",
    isError: false,
    errorMsg: "",
  });
  const [facilitySize, setFacilitySize] = useState({
    value: selectedFacility?.facilitySize ?? "",
    isError: false,
    errorMsg: "",
  });
  const [description, setDescription] = useState({
    value: selectedFacility?.description ?? "",
    isError: false,
    errorMsg: "",
  });

  const validateName = (name: string) => {
    if (name.length < 2) {
      setFacilityName((prevState) => ({
        ...prevState,
        isError: true,
        errorMsg: "Please enter a valid name",
      }));
      return false;
    } else {
      setFacilityName((prevState) => ({
        ...prevState,
        isError: false,
        errorMsg: "",
      }));
      return true;
    }
  };

  const validateFacilityType = (type: string) => {
    if (type === "Select Store Type") {
      setFacilityTypeId((prevState) => ({
        ...prevState,
        isError: true,
        errorMsg: "Please select a store type",
      }));
      return false;
    } else {
      setFacilityTypeId((prevState) => ({
        ...prevState,
        isError: false,
        errorMsg: "",
      }));
      return true;
    }
  };

  // const validateFacilitySize = (size: string) => {
  //   if (!size || size === "" || !Number.isInteger(Number(size)) || Number(size) <= 0) {
  //     setFacilitySize((prevState) => ({
  //       ...prevState,
  //       isError: true,
  //       errorMsg: "Please enter a valid size",
  //     }));
  //     return false;
  //   } else {
  //     setFacilitySize((prevState) => ({
  //       ...prevState,
  //       isError: false,
  //       errorMsg: "",
  //     }));
  //     return true;
  //   }
  // };

  const validateDescription = (description: string) => {
    if (description !== "" && isValidStringInput(description)) {
      setDescription((prevState) => ({
        ...prevState,
        isError: false,
        errorMsg: "",
      }));
      return true;
    } else {
      setDescription((prevState) => ({
        ...prevState,
        isError: true,
        errorMsg: "Please enter a valid description",
      }));
      return false;
    }
  };
  const handleAddFacility = () => {
    if (
      validateName(facilityName.value) &&
      validateFacilityType(facilityTypeId.value) &&
      validateDescription(description.value)
    ) {

      //Call API
      const reqBody: any = {
        facilityTypeId: facilityTypeId.value,
        parentFacilityId: "",
        facilityName: facilityName.value,
        size: facilitySize.value,
        description: description.value,
      };
      if(pageMode === "EDIT" && selectedFacility && selectedFacility?._id) {
        reqBody.facilityId = selectedFacility?._id;
      }
      // console.log(reqBody);

      if(pageMode === "ADD") {
        store.dispatch(createFacility(reqBody)).unwrap().then((res: any) => {
          // console.log(res);
          if (res.status === 200) {
            handleSetSuccess("Successfully created the store.")
            addFacility(res?.data?.facility);
            handleCancelClick()
          }
          else {
            // handle error when facility is not created
            handleSetError(res.error)
            console.log(res.error)
          }
        }).catch((error) => {
          handleSetError(error?.error)
        })
      }
      else if(pageMode === "EDIT") {
        store.dispatch(updateFacility(reqBody)).unwrap().then((res: any) => {
          // console.log(res);
          if (res.status === 200) {
            handleSetSuccess("Successfully updated the store.")
            editFacility(res?.data?.updatedFacility)
            handleCancelClick()
          }
          else {
            // handle error when facility is not created
            handleSetError(res.error)
            console.log(res.error)
          }
        }).catch((error) => {
          handleSetError(error?.error)
        })
      }
    }
  };
  return (
    <>
      <Box className="addFacilityBox">
        <Box className="addFacilityFormsContainer">
          <FormControl
            fullWidth
            sx={{ mt: 2 }}
            variant="standard"
            className="addFacility_input_field"
          >
            <FormLabel>Store Name</FormLabel>
            <TextField
              id="Name"
              variant="standard"
              placeholder="Store Name"
              value={facilityName.value}
              error={facilityName.isError}
              helperText={facilityName.errorMsg}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFacilityName((prevState) => ({
                  ...prevState,
                  value: event.target.value,
                  isError: false,
                  errorMsg: "",
                }));
              }}
              className="addFacilityinput_text"
            />
          </FormControl>
        </Box>
        <Box className="addFacilityFormsContainer">
          <FormControl
            fullWidth
            sx={{ mt: 2, width: { xs: "100%", md: "40%" } }}
            variant="filled"
            className="addFacility_input_field"
          >
            <FormLabel>Store Type</FormLabel>
            <Select
              labelId="select-role"
              id="select-role"
              value={facilityTypeId.value}
              onChange={(event: SelectChangeEvent) => {
                setFacilityTypeId((prevState) => ({
                  ...prevState,
                  value: event.target.value,
                  isError: false,
                  errorMsg: "",
                }));
              }}
              className={facilityTypeId.value === "Select Store Type" ? "baseSelect" : ""}
              error={facilityTypeId.isError}
            >
              <MenuItem value={"Select Store Type"} disabled>
                Select Store Type
              </MenuItem>
              <MenuItem value={"STORE"}> Store </MenuItem>
            </Select>
            <FormHelperText sx={{ color: "red" }}>
              {facilityTypeId.errorMsg}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box className="addFacilityFormsContainer">
          {/* <FormControl
            fullWidth
            sx={{ mt: 2 }}
            variant="standard"
            className="addFacility_input_field"
          >
            <FormLabel>Size</FormLabel>
            <TextField
              id="size"
              variant="standard"
              type="number"
              placeholder="Enter facility size"
              value={facilitySize.value}
              error={facilitySize.isError}
              helperText={facilitySize.errorMsg}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFacilitySize((prevState) => ({
                  ...prevState,
                  value: event.target.value,
                  isError: false,
                  errorMsg: "",
                }));
              }}
              className="addFacilityinput_text"
            />
          </FormControl> */}
          <Box
            sx={{
              width: { xs: "100%", md: "40%" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
            }}
          >
            <FormLabel className="addFacilityPhoneNumberLabel">
              Description
            </FormLabel>
            <FormControl
              fullWidth
              sx={{ width: "100% !important" }}
              variant="standard"
              className="addFacility_input_field"
            >
              <TextField
                id="description"
                variant="standard"
                placeholder="Description"
                value={description.value}
                error={description.isError}
                helperText={description.errorMsg}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setDescription((prevState) => ({
                    ...prevState,
                    value: event.target.value,
                    isError: false,
                    errorMsg: "",
                  }));
                }}
                className="addFacilityinput_text"
              />
            </FormControl>
          </Box>
        </Box>
        <Box className="addFacilityBtnsContainer">
          <LoadingButton
            loadingPosition="center"
            variant="contained"
            className="addNewFacilityBtn"
            onClick={handleAddFacility}
            disabled={storeFacilityState.loading}
          >
            {pageMode === "ADD" ? "Add new store" : pageMode === "EDIT" ? "Edit store" : ""}
          </LoadingButton>
          <Button
            variant="contained"
            className="addNewFacilityBtn"
            onClick={handleCancelClick}
            sx={{
              backgroundColor: "#F0F0F0 !important",
              color: " #22438C !important",
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </>
  );
};
